import React from "react";
import "./Header.css";

const Header = () => (
  <header className="header">
    <nav className="header__nav">
      <a href="#products">Products</a>
      <a href="#services">Services</a>
      <a href="#contact">Contact</a>
    </nav>
  </header>
);

export default Header;
